(() => {
  // Native product additions stay on the current page. Read the authoritative
  // cart total after success so the header matches the confirmation on the card.
  let cartRefresh = 0;
  document.addEventListener('bdtf:cart-change', async () => {
    const link = document.querySelector('.cart-link');
    if (!link) return;
    const revision = ++cartRefresh;
    try {
      const url = new URL(link.href);
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(url, {cache: 'no-store', signal: AbortSignal.timeout(15000)});
      if (!response.ok) return;
      const cart = await response.json();
      if (revision !== cartRefresh || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
      document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = String(cart.item_count); });
      const label = link.getAttribute('aria-label') || '';
      link.setAttribute('aria-label', label.replace(/\s*\(\d+\)$/, '') + ` (${cart.item_count})`);
    } catch { /* Keep the existing count if the cart cannot be refreshed. */ }
  });
  const toolbar = document.querySelector('.header-inner');
  const dispatch = document.querySelector('.dispatch-bar');
  const workspaceHeader = document.querySelector('.is-builder .site-header');
  // Measure the persistent toolbar, not the expanded mobile menu.
  if (toolbar) {
    const measureHeader = () => {
      const height = Math.ceil(toolbar.getBoundingClientRect().height + (dispatch?.getBoundingClientRect().height || 0) + 1);
      document.documentElement.style.setProperty('--site-header-height', `${height}px`);
      document.documentElement.style.setProperty('--builder-header-height', `${height}px`);
    };
    const observer = new ResizeObserver(measureHeader);
    observer.observe(toolbar);
    if (dispatch) observer.observe(dispatch);
    measureHeader();
  }
  // The builder loads asynchronously. Measure its mobile order bar without
  // duplicating controls or changing their cart event handlers.
  if (workspaceHeader) {
    const workspace = document.getElementById('dtf-builder-root');
    const observeSummary = () => {
      const summary = workspace?.querySelector('.preview-header');
      if (!summary) return false;
      new ResizeObserver(() => document.documentElement.style.setProperty('--builder-summary-height', `${summary.getBoundingClientRect().height}px`)).observe(summary);
      return true;
    };
    if (workspace && !observeSummary()) {
      const observer = new MutationObserver(() => { if (observeSummary()) observer.disconnect(); });
      observer.observe(workspace, {childList:true,subtree:true});
    }
  }
  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  const closeMenu = () => { if (!menu || !menuButton) return; menu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label',menuButton.dataset.openLabel); };
  menuButton?.addEventListener('click', () => {
    menu.hidden = !menu.hidden;
    menuButton.setAttribute('aria-expanded', String(!menu.hidden));
    menuButton.setAttribute('aria-label',menu.hidden?menuButton.dataset.openLabel:menuButton.dataset.closeLabel);
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) { closeMenu(); menuButton.focus(); } });
  matchMedia('(min-width: 1441px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  const orderLinks = [...document.querySelectorAll('[data-order-nav]')];
  const syncOrderNavigation = galleryOpen => {
    const builder = !!document.getElementById('dtf-builder-root');
    const shop = !!document.querySelector('[data-design-library], transfer-options[data-pdp], [data-native-collection]');
    const active = builder ? (galleryOpen ?? new URL(location.href).searchParams.has('gallery') ? 'library' : 'builder') : shop ? 'shop' : null;
    for (const link of orderLinks) {
      if (link.dataset.orderNav === active) link.setAttribute('aria-current', 'page');
      else if (active || link.dataset.orderNav !== 'shop') link.removeAttribute('aria-current');
    }
  };
  syncOrderNavigation();
  document.addEventListener('bdtf:gallery-state', event => syncOrderNavigation(event.detail.open));
  window.addEventListener('popstate', () => syncOrderNavigation());
  for (const link of orderLinks) link.addEventListener('click', async event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !document.getElementById('dtf-builder-root')) return;
    if (['builder', 'library'].includes(link.dataset.orderNav) && window.setBuilderLibraryOpen) {
      event.preventDefault();
      window.setBuilderLibraryOpen(link.dataset.orderNav === 'library');
      closeMenu();
    } else if (window.prepareBuilderNavigation) {
      event.preventDefault();
      if (await window.prepareBuilderNavigation()) location.assign(link.href);
    }
  });
  document.querySelectorAll('.language-form').forEach(form => {
    const select = form.querySelector('[name="language_code"]');
    let current = select.value;
    let switching = false;
    select.addEventListener('change', async () => {
      if (switching || select.value === current) return;
      switching = true;
      select.setAttribute('aria-busy', 'true');
      try {
        if (window.prepareBuilderNavigation && !await window.prepareBuilderNavigation()) {
          select.value = current;
          return;
        }
        // Shopify's native localization redirect must use the current variant,
        // not the URL captured when the page was rendered. Carry the pending
        // PDP quantity too; this does not add anything to the cart.
        const destination = new URL(location.href);
        const quantity = document.querySelector('transfer-options[data-pdp] [data-transfer-quantity]');
        if (quantity) {
          if (!quantity.checkValidity()) { select.value = current; quantity.reportValidity(); return; }
          destination.searchParams.set('quantity', quantity.value);
        }
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = destination.pathname + destination.search + destination.hash;
        form.requestSubmit();
      } finally {
        switching = false;
        select.removeAttribute('aria-busy');
      }
    });
  });
  document.querySelectorAll('.guide-links a').forEach(link => {
    if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
  });
  const categorySearch = document.querySelector('[data-category-search]');
  categorySearch?.addEventListener('input', () => {
    const query = categorySearch.value.trim().toLocaleLowerCase();
    let visible = 0;
    document.querySelectorAll('[data-category-title]').forEach(card => { card.hidden = !card.dataset.categoryTitle.toLocaleLowerCase().includes(query); if (!card.hidden) visible++; });
    const status = document.querySelector('[data-category-count]');
    if (status) status.textContent = String(visible);
    const empty = document.querySelector('[data-category-empty]'); if (empty) empty.hidden = visible > 0;
  });
})();
